import { DeleteColumnOutlined, DeleteRowOutlined, EditFilled } from '@ant-design/icons';
import { Button, Popconfirm, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import _Api from 'services/Api/_Api';

function DataDiet({ jenisdiet_id, refresh }) {


    const [listWaktuMakan, setlistWaktuMakan] = useState([])
    const [listDiet, setlistDiet] = useState([])
    const [jenisDietINI, setjenisDietINI] = useState("")
    const [dataJenisDiet, setdataJenisDiet] = useState([])
    const [rowSpanMap, setRowSpanMap] = useState({});


    const getlistDiet = () => {
        _Api.get("get-list-diet?jenisdiet_id=" + jenisdiet_id)
            .then(rr => {
                const data = rr.data.data;

                // Menghitung rowSpan hanya satu kali tanpa menggunakan filter() berulang
                const newRowSpanMap = {};
                let prevWaktuMakan = null;
                let count = 0;

                data.forEach((item, index) => {
                    if (item.waktumakan !== prevWaktuMakan) {
                        count = data.filter(d => d.waktumakan === item.waktumakan).length;
                        newRowSpanMap[item.waktumakan] = count;
                    }
                    prevWaktuMakan = item.waktumakan;
                });

                // Simpan rowSpanMap dan data ke state
                setRowSpanMap(newRowSpanMap);
                setdataJenisDiet(data);
            })
            .catch(error => {
                console.error("Error fetching data:", error);
            });
    };

    const hapusNilaiGizi = (dt) => {
        console.log(dt)
        _Api.get("hapus-mapping-nilai-gizi?id=" + dt.id).then(tt => {
            console.log(tt)
            getlistDiet()
        })
    }

    useEffect(() => {
        getlistDiet()
    }, [jenisdiet_id, refresh])

    const columns = [
        {
            title: "Waktu Makan",
            dataIndex: "waktumakan",
            width : "500px",
            render: (value, record, index) => {
                const rowSpan = rowSpanMap[value];
                if (index > 0 && dataJenisDiet[index - 1].waktumakan === value) {
                    return { props: { rowSpan: 0 } };
                }
                return { children: "➥ " + value, props: { rowSpan } };
            },
        },
        {
            title: "Jenis Makanan",
            dataIndex: "nilaigizi",
            width : "800px",
            render: (value, record, index) => (
                <div>
                    {value}

                    <Popconfirm
                        title="Hati - hati, anda akan menghapus nilai gizi ini permanent ?"
                        onConfirm={() => hapusNilaiGizi(record)}
                        okText="Ya, Hapus"
                        cancelText="Jangan">

                        <Button type="link" danger icon={<DeleteRowOutlined />}></Button>
                    </Popconfirm>
                    &nbsp;
                    {/* <Button type="link" style={{ color: "orange" }} icon={<EditFilled />}></Button> */}
                </div>
            ),
            key: "nilaigizi",
        },
        {
            title: "Porsi",
            width : "200px",
            dataIndex: "berat",
            key: "berat",
            render: (value, record, index) => (value + " gr")
        },
        {
            width : "200px",
            title: "URT",
            dataIndex: "urt",
            key: "urt",
        },
    ];


    return (
        <div className='overflow-auto'>
            <Table style={{minWidth : "800px"}} bordered dataSource={dataJenisDiet} columns={columns} pagination={false} />
        </div>
    )
}

export default DataDiet